import {
  AdvancedMarker,
  InfoWindow,
  Pin,
  useAdvancedMarkerRef,
} from '@vis.gl/react-google-maps'
import { observer } from 'mobx-react'
import React, { useCallback } from 'react'
import { Suspense } from 'react'

import InfoWindowContent from './InfoWindowContent'
import Loading from './Loading'

const MapLocationMarker = ({ location, onClick, theme, store }) => {
  const [markerRef, marker] = useAdvancedMarkerRef()
  const handleClick = useCallback(() => onClick(location), [onClick, location])

  return (
    <AdvancedMarker
      position={{ lat: location.latNumber, lng: location.lngNumber }}
      ref={markerRef}
      onClick={handleClick}
    >
      <Pin
        borderColor={theme.palette.primary.main}
        background={theme.palette.primary.light}
        glyphColor={theme.palette.primary.main}
      />
      {store.locationStore.infoWindowOpen &&
      store.locationStore.focusLocation &&
      store.locationStore.focusLocation.id === location.id ? (
        <InfoWindow
          anchor={marker}
          disableAutoPan
          maxWidth={408}
          onCloseClick={() => store.locationStore.resetFocusLocation()}
        >
          <Suspense
            fallback={<Loading message={'Loading InfoWindow Content...'} />}
          >
            <InfoWindowContent location={location} />
          </Suspense>
        </InfoWindow>
      ) : null}
    </AdvancedMarker>
  )
}

export default observer(MapLocationMarker)
